// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".stationMapView .stationMap__container{height:calc(100vh - 140px);margin:-30px}", "",{"version":3,"sources":["/home/jenkins/agent/workspace/dashboard_gsa/src/views/auth/StationMap.vue"],"names":[],"mappings":"AAUI,uCACE,0BAAA,CACA,YAAA","file":"StationMap.vue","sourcesContent":["@import \"@/styles/_variables.scss\";\n\n\n\n\n\n\n\n.stationMapView {\n  .stationMap {\n    &__container {\n      height: calc(100vh - 140px);\n      margin: -30px;\n    }\n  }\n}\n"]}]);
// Exports
module.exports = exports;
